export class SavedWheelDetails{
    constructor(tyreIsDamaged, profileDepth, mainPhoto, detailPhotos,rimIsDamaged) {
        this.tyreIsDamaged = tyreIsDamaged;
        this.profileDepth = profileDepth;
        this.mainPhoto = mainPhoto;
        this.detailPhotos = detailPhotos;
        this.rimIsDamaged = this.rimIsDamaged
    }
  }